import React from 'react';
import PropTypes from 'prop-types';

/**
 * SelectDropdown component for form use.
 * Props:
 *  - label: string (label text)
 *  - value: string (current value)
 *  - onChange: function (called with event)
 *  - options: array of strings (option values)
 *  - placeholder: string (default unselected text)
 *  - disabled: bool
 */
export default function SelectDropdown({
  label,
  value,
  onChange,
  options,
  placeholder = 'Please select an option',
  disabled = false
}) {
  return (
    <div className="form-group">
      <label className="form-label">
        {label}
        <select
          className="form-select"
          value={value}
          onChange={onChange}
          disabled={disabled}
        >
          <option value="">{placeholder}</option>
          {options.map((opt) => (
            <option key={opt} value={opt}>{opt}</option>
          ))}
        </select>
      </label>
    </div>
  );
}

SelectDropdown.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
};
